import type { StatusTone } from '@vnetwork/ui/data';

/**
 * Status/tier → @vnetwork/ui StatusTone mappings for StatusPill and inline
 * badges. Only the union members declared in StatusPill.tsx are valid:
 * neutral | success | warning | danger | info | muted.
 */

export function resellerStatusTone(status: string): StatusTone {
  switch (status) {
    case 'active':    return 'success';
    case 'suspended': return 'danger';
    case 'inactive':  return 'muted';
    default:          return 'neutral';
  }
}

export function resellerTierTone(tier: string): StatusTone {
  switch (tier) {
    case 'platinum': return 'info';
    case 'gold':     return 'warning';
    case 'silver':   return 'neutral';
    case 'bronze':   return 'muted';
    default:         return 'neutral';
  }
}

/** Human-readable label from a raw status/tier string. */
export function humanize(s: string): string {
  if (!s) return '—';
  return s.charAt(0).toUpperCase() + s.slice(1).replace(/-/g, ' ');
}
